import React from "react";
import { StyledButton } from "../styles/Button.styled";
import {
  Name,
  StyledButtonsContainer,
  StyledHome,
  Title,
  Line,
  Greeting,
  Social,
  Socials,
  Quote,
} from "../styles/Home.styled";
import "./style.css";
import projectIcon from "../../assets/icons/project-icon.svg";
import { IconContext } from "react-icons";
import { GrLinkedinOption } from "react-icons/gr";
import { GoMarkGithub } from "react-icons/go";
import { FaEnvelope } from "react-icons/fa";
import { ResumeLink } from "../styles/About.styled";

const Home = () => {
  let today = new Date(),
    hour = today.getHours(); 

  return (
    <IconContext.Provider value={{ size: "1rem" }}>
      <StyledHome id="home">
        <Name>Abhijeet Hiwale</Name>
        <Title>Full Stack Developer</Title>
        <p>
          I <span className="change-text"></span>{" "}
          <span className="responsive">f</span>
          <span className="responsive">u</span>
          <span className="responsive">l</span>
          <span className="responsive">l</span>
          <span className="responsive">s</span>
          <span className="responsive">t</span>
          <span className="responsive">a</span>
          <span className="responsive">c</span>
          <span className="responsive">k</span> websites.
        </p>
        <StyledButtonsContainer>
          <StyledButton
            icon={projectIcon}
            to="projects"
            smooth={true}
            duration={0}
            delay={0}
            spy={true}
            spyThrottle={0}
            exact="true"
            offset={-50}
          >
            <span>Projects</span>
          </StyledButton>
          
            <ResumeLink
              href="https://drive.google.com/file/d/10LfP8SnhcHtTcmJuvuFvdPHun7LkjHeL/view?usp=drive_link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Resume
            </ResumeLink>
          
        </StyledButtonsContainer>
        <Line />
        <Greeting>
          Have a great
          <span>
            {hour < 12 ? " morning" : hour < 18 ? " afternoon" : " evening"}
          </span>
          !
        </Greeting>
        <Socials>
          <Social
            href="mailto:abhijeethiwalemail@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaEnvelope />
          </Social>
          <Social
            href="https://github.com/Abhii-07"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GoMarkGithub />
          </Social>
          <Social
            href="https://www.linkedin.com/in/abhijeethiwale"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GrLinkedinOption />
          </Social>
        </Socials>
        <Quote>Master your mind and anything is possible!</Quote>
      </StyledHome>
    </IconContext.Provider>
  );
};

export default Home;
